import {Rect} from '../types';

export const scaleRect = (
  rect: Rect,
  scale: {x: number; y: number},
  offset: {x?: number; y?: number} = {},
): Rect => ({
  ...rect,
  x: (rect.x - (offset.x || 0)) * scale.x + (offset.x || 0),
  y: (rect.y - (offset.y || 0)) * scale.y + (offset.y || 0),
  width: rect.width * scale.x,
  height: rect.height * scale.y,
});
